module.exports = __webpack_public_path__ + "img/Grupo 1668@2x.47bd402a.png";